import { GET_ALL_TOKENS } from './mutation-types'

export default {
  [GET_ALL_TOKENS]: (state, tokens) => {
    state.tokens = tokens
  },
}
